import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Button } from '../ui/button.jsx';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    if (typeof window !== 'undefined') {
      // Keep console noise low but still traceable in dev
      console.error('ErrorBoundary caught:', error);
    }
  }

  handleReload = () => {
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="min-h-[60vh] flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-gray-900 border border-gray-800 rounded-2xl p-6 text-center text-white">
          <div className="flex justify-center mb-3">
            <div className="w-12 h-12 rounded-full bg-red-500/15 text-red-300 flex items-center justify-center">
              <AlertCircle className="w-6 h-6" />
            </div>
          </div>
          <h2 className="text-lg font-semibold">Algo salió mal</h2>
          <p className="text-sm text-gray-400 mt-2">
            Ocurrió un error inesperado. Puedes recargar la página para continuar.
          </p>
          <Button
            onClick={this.handleReload}
            className="mt-4 bg-amber-500 hover:bg-amber-600 text-black"
          >
            Recargar
          </Button>
        </div>
      </div>
    );
  }
}
